module.exports = __webpack_public_path__ + "static/media/5trillion@2x.ef99020d.png";